import { render } from "./reportealertas.vue?vue&type=template&id=c8243f4c"
import script from "./reportealertas.vue?vue&type=script&lang=js"
export * from "./reportealertas.vue?vue&type=script&lang=js"

import "./reportealertas.vue?vue&type=style&index=0&id=c8243f4c&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__